import { useQuery } from '@tanstack/react-query';

import { me } from '../authService';

const useMe = () => {
  return useQuery({
    queryKey: ['me'],
    queryFn: () => me().then((r) => r.data),
    staleTime: 60_000,
  });
};

export default useMe;
